import { Scheme } from '../../proto/tumelo/stewardshipbff/v1/scheme'

export const sampleScheme = (override?: Partial<Scheme>): Scheme =>
  Scheme.fromPartial({
    name: 'habitats/ca37f743-90e2-4f44-bee9-cd004236fdf9/schemes/83c58afa-78c5-4573-aa4d-98270834d602',
    title: 'Test Scheme',
    investorName: 'habitats/ca37f743-90e2-4f44-bee9-cd004236fdf9/investors/83c58afa-78c5-4573-aa4d-98270834d602',
    ...override,
  })
